import { FC, Suspense, lazy, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MainRoutes, ROUTES } from "common/config";
import SideNav from "./side-nav";
// import { CookieConsent } from "common/components/custom/cookie";
import useCookie from "common/hooks/useCookie";
import { CookiePolicy, CookieSettings } from "common/components";
import { Loading, UnAuthorized } from "modules/_shared/pages";
import "./AuthorizedLayout.scss";
import SessionTimeOutModal from "common/components/custom/session-timeout-modal/SessionTimeoutModal";
import { useAppSelector } from "common/redux/core";
import AuthProvider from "common/components/custom/auth-provider";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { authRequest } from "common/config/auth.config";
import useAppPermission from "common/hooks/useAppPermission";
import TopHeader from "./top-header/TopHeader";
// import Footer from "common/components/custom/footer/Footer";
import DocumentUploader from "modules/documents/pages/document-parser/DocumentUploader";
import DocumentParser from "modules/documents/pages/document-parser/DocumentParser";
import UploadConfig from "modules/documents/pages/document-parser/UploadConfig";
import NewDocumentUpload from "modules/documents/pages/document-parser/NewDocumentUpload";
import NewDocumentUploader from "modules/documents/pages/document-parser/NewDocumentUploader";
import DocumentTypePage from "modules/configuration-hub/pages/document-type-page/DocumentType";
import ConfigureOps from "modules/configuration-hub/pages/configure-ops-page/ConfigureOps";
import DocumentOperation from "modules/configuration-hub/pages/document-operation-page/DocumentOperation";
import Assignment from "modules/configuration-hub/pages/assignment-page/Assignment";
import TagLibraryConfigList from "modules/configuration-hub/pages/tag-library/tag-library-config/TagLibraryConfigList";
import CreateTagLibraryConfig from "modules/configuration-hub/pages/tag-library/create-tag-library-config/CreateTagLibraryConfig";
import TagEnrichmentPage from "modules/configuration-hub/pages/tag-library/tag-enrichment-phase-page/TagEnrichmentPage";
import CompleteTagLibrary from "modules/configuration-hub/pages/tag-library/complete-tag-library/CompleteTagLibrary";
import AvailableConfiguration from "modules/configuration-hub/pages/extraction-configuration/available-configuration/AvailableConfiguration";
import AvailableTools from "modules/configuration-hub/pages/extraction-configuration/tool-validator/available-tools/AvailableTools";
import ToolValidation from "modules/configuration-hub/pages/extraction-configuration/tool-validator/available-tools/ToolValidation";
import ToolDevelopment from "modules/configuration-hub/pages/extraction-configuration/tool-validator/tool-development/ToolDevelopment";
import { Upload as UploadPage } from "modules/processing-hub";
import UploadGDX from "modules/processing-hub/pages/upload-gdx/UploadGdx";
import AIChatbotPage from "modules/ai-chatbot/pages/AIChatbotPage";
import { DataIntegration } from "modules/data_integration-hub";
import { DataClassificationHub } from "modules/data-classification-hub";
import DocumentHistoryPage from "modules/data-classification-hub/pages/document-history/DocumentHistoryPage";
import CategoriesOverviewPage from "modules/data-classification-hub/pages/category-overview/CategoriesOverviewPage";
import CategoryDetailPage from "modules/data-classification-hub/pages/category-detils/CategoryDetailPage";
import BatchExtractionResultsPage from "modules/data-classification-hub/pages/quality-hub/batch-extraction/BatchExtractionResultsPage";
import { BatchQualityAssessmentPage } from "modules/data-classification-hub/pages";
import AvailableDataTable from "modules/data_integration-hub/pages/available-tables/AvailableDataTable";
import DataFilterBuilderPage from "modules/data_integration-hub/pages/data-filter-builder/DataFilterBuilderPage";
import DataMappingInterface from "modules/data_integration-hub/pages/data-mapping-interface/DataMappingInterface";
import PredictiveMaintenanceDashboard from "modules/data_integration-hub/pages/predictive-maintenance/PredictiveMaintenanceDashboard";
import FlowBuilder from "modules/data_integration-hub/pages/flow-builder/FlowBuilder";
import SnowflakeDataViewer from "modules/data_integration-hub/pages/snowflake-data-viewer/SnowflakeDataViewer";
import AISearchHub from "modules/Ai_search_hub/pages/search-page/SearchHub";
import FloatingChatbot from "modules/ai-chatbot/components/FloatingChatbot";
import KnowledgeLibrary from "modules/knowledge-library/pages/knowledge-library/KnowledgeLibrary";
import ViewData from "modules/knowledge-library/pages/view-knowledge-data/ViewData";
import SearchDetails from "modules/Ai_search_hub/pages/search-details-page/SearchDetails";
import KnowledgeAgent from "modules/knowledge-agent/pages/knowledge-agent-page/KnowledgeAgent";
import AgentAllDetails from "modules/knowledge-agent/pages/knowledge-agent-all-details/AgentAllDetails";
import AgentSessionView from "modules/knowledge-agent/pages/knowledge-agent-session-view/AgentSessionView";
import PackagingWorkspace from "modules/knowledge-agent/pages/engg-packaging/PackagingWorkspace";
import LandingNew from "modules/home/pages/landingNew-page/LandingNew";
import ManagementOfChange from "modules/management-of-change/pages/management-of-change/ManagementOfChange";
import CreateMoc from "modules/management-of-change/pages/create-moc/CreateMoc";
import RelationshipValidation from "modules/processing-hub/pages/relationship-validation/RelationshipValidation";
import DrawingIntelligence from "modules/processing-hub/pages/drawing-intelligence/DrawingIntelligence";
import CreateOntology from "modules/ontology/pages/create-ontology/CreateOntology";
import CreateOntologyInitiative from "modules/ontology/pages/create-ontology-initiative/CreateOntologyInitiative";
import CreateOntologyQuestions from "modules/ontology/pages/create-ontology-questions/CreateOntologyQuestions";
import CreateOntologyCqReview from "modules/ontology/pages/create-ontology-cq-review/CreateOntologyCqReview";
import CreateOntologyEntitiesRelationships from "modules/ontology/pages/create-ontology-entities-relationships/CreateOntologyEntitiesRelationships";
import CreateOntologyReuseHarmonisation from "modules/ontology/pages/create-ontology-reuse-harmonisation/CreateOntologyReuseHarmonisation";
import CreateOntologyGroundToDocuments from "modules/ontology/pages/create-ontology-ground-to-documents/CreateOntologyGroundToDocuments";
import CreateOntologyBuildKnowledgeGraph from "modules/ontology/pages/create-ontology-build-knowledge-graph/CreateOntologyBuildKnowledgeGraph";
import CreateOntologyValidateRelease from "modules/ontology/pages/create-ontology-validate-release/CreateOntologyValidateRelease";
import OntologyLibrary from "modules/ontology/pages/ontology-library/OntologyLibrary";
//Lazy Loaded Components
// const Dashboard = lazy(() => import("modules/home/pages/dashboard/Dashboard"));

// const Home = lazy(() => import("modules/home/pages/home/Home"));

const Home = lazy(
  () => import("modules/Ai_search_hub/pages/search-page/SearchHub")
);

const DocumentList = lazy(
  () => import("modules/documents/pages/document-list/DocumentList")
);

const DocumentDetails = lazy(
  () => import("modules/documents/pages/document-details/DocumentDetails")
);

const UsersList = lazy(
  () => import("modules/user-management/pages/users-list/UsersList")
);

const MetricDashboard = lazy(
  () =>
    import("modules/metric-dashboard/pages/metric-dashboard/MetricDashboard")
);

const SimilarRequirements = lazy(
  () =>
    import("modules/documents/pages/similar-requirements/SimilarRequirements")
);

const MetricsTimelines = lazy(
  () =>
    import("modules/metric-dashboard/pages/metrics-timeline/MetricsTimeline")
);

const DocumentSetup = lazy(
  () => import("modules/documents/pages/document-setup/DocumentList")
);

const AuthorizedLayout: FC = () => {
  const {
    showCookieConsent,
    canCurrentPageAppearBeforeCookieConsent,
    handleAcceptAllCookies,
    handleDeclineOptionalCookies
  } = useCookie();

  const status = useAppSelector((state) => state.user.accessStatus);

  const { hasAdminRole } = useAppPermission();

  const [isSideNavCollapsed, setSideNavCollapsed] = useState(true);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      loadingComponent={Loading}
      errorComponent={UnAuthorized}
    >
      <AuthProvider profileStatus={status}>
        {/* {showCookieConsent && (
          <CookieConsent
            onAcceptAll={handleAcceptAllCookies}
            onDecline={handleDeclineOptionalCookies}
          />
        )} */}
        <TopHeader />
        <main className="app-layout">
          <SideNav collapsed={isSideNavCollapsed} />
          <div className="app-layout-wrapper">
            <div>
              <Suspense fallback={<Loading />}>
                <Routes>
                  <Route path={"cookie-policy"} element={<CookiePolicy />} />
                  {/* <Route path={"cookie-settings"} element={<CookieSettings />} /> */}
                  {hasAdminRole ? (
                    <Route path={MainRoutes.USERS} element={<UsersList />} />
                  ) : (
                    <Route
                      path={MainRoutes.USERS}
                      element={<Navigate to={MainRoutes.HOME} />}
                    />
                  )}
                  <Route
                    path={MainRoutes.DOCUMENTS}
                    element={<DocumentList />}
                  />
                  <Route
                    path={MainRoutes.DOCUMENT_DETAILS}
                    element={<DocumentDetails />}
                  />
                  <Route
                    path={MainRoutes.SIMILAR_REQUIREMENTS}
                    element={<SimilarRequirements />}
                  />
                  <Route
                    path={MainRoutes.METRICS_TIMELINE}
                    element={<MetricsTimelines />}
                  />
                  <Route path={MainRoutes.HOME} element={<LandingNew />} />
                  <Route path={MainRoutes.AI_SEARCH_HUB} element={<Home />} />
                  <Route
                    path={MainRoutes.MANAGEMENT_OF_CHANGE}
                    element={<ManagementOfChange />}
                  />
                  <Route path={MainRoutes.CREATE_MOC} element={<CreateMoc />} />
                  <Route
                    path={MainRoutes.RELATIONSHIP_VALIDATION}
                    element={<RelationshipValidation />}
                  />
                  <Route
                    path={MainRoutes.DRAWING_INTELLIGENCE}
                    element={<DrawingIntelligence />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY}
                    element={<CreateOntology />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_INITIATIVE}
                    element={<CreateOntologyInitiative />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_QUESTIONS}
                    element={<CreateOntologyQuestions />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_CQ_REVIEW}
                    element={<CreateOntologyCqReview />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_ENTITIES_RELATIONSHIPS}
                    element={<CreateOntologyEntitiesRelationships />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_REUSE_HARMONISATION}
                    element={<CreateOntologyReuseHarmonisation />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_GROUND_TO_DOCUMENTS}
                    element={<CreateOntologyGroundToDocuments />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_BUILD_KNOWLEDGE_GRAPH}
                    element={<CreateOntologyBuildKnowledgeGraph />}
                  />
                  <Route
                    path={MainRoutes.CREATE_ONTOLOGY_VALIDATE_RELEASE}
                    element={<CreateOntologyValidateRelease />}
                  />
                  <Route
                    path={MainRoutes.ONTOLOGY_LIBRARY}
                    element={<OntologyLibrary />}
                  />
                  <Route
                    path={MainRoutes.METRIC_DASHBOARD}
                    element={<MetricDashboard />}
                  />
                  {/* <Route
                    path={MainRoutes.AI_SEARCH_HUB}
                    element={<AISearchHub />}
                  /> */}
                  <Route
                    path={ROUTES.DEFAULT}
                    element={<Navigate to={MainRoutes.HOME} />}
                  />
                  <Route
                    path={ROUTES.WILD}
                    element={<Navigate to={MainRoutes.HOME} />}
                  />
                  <Route
                    path={MainRoutes.DOCUMENT_SETUP}
                    element={<DocumentSetup />}
                  />
                  {/* <Route
                    path={MainRoutes.BULK_UPLOAD}
                    element={<DocumentParser />}
                  />
                  <Route
                    path={`${MainRoutes.BULK_UPLOAD}/:docType`}
                    element={<DocumentUploader />}
                  /> */}

                  <Route
                    path={MainRoutes.BULK_UPLOAD}
                    element={<UploadConfig />}
                  />
                  <Route
                    path={`${MainRoutes.BULK_UPLOAD}/new`}
                    element={<NewDocumentUpload />}
                  />
                  <Route
                    path={`${MainRoutes.BULK_UPLOAD}/parser`}
                    element={<DocumentParser />}
                  />
                  <Route
                    path={`${MainRoutes.BULK_UPLOAD}/:docType`}
                    element={<DocumentUploader />}
                  />
                  <Route
                    path={`${MainRoutes.BULK_UPLOAD}/NewDocument`}
                    element={<NewDocumentUploader />}
                  />
                  <Route
                    path={MainRoutes.CONFIGURE}
                    element={<DocumentTypePage />}
                  />
                  <Route
                    path={MainRoutes.PROCESSING}
                    element={<UploadPage />}
                  />
                  <Route path={MainRoutes.UPLOAD_GDX} element={<UploadGDX />} />
                  <Route
                    path={MainRoutes.CONFIGURE_OPS}
                    element={<ConfigureOps />}
                  />
                  <Route
                    path={MainRoutes.DOCUMENT_OPERATION}
                    element={<DocumentOperation />}
                  />
                  <Route
                    path={MainRoutes.EXTRACTION_CONFIGURATION}
                    element={<AvailableConfiguration />}
                  />
                  <Route
                    path={MainRoutes.AVAILABLE_TOOLS}
                    element={<AvailableTools />}
                  />
                  <Route
                    path={MainRoutes.TOOL_VALIDATION}
                    element={<ToolValidation />}
                  />
                  <Route
                    path={MainRoutes.TOOL_DEVELOPMENT}
                    element={<ToolDevelopment />}
                  />
                  <Route
                    path={MainRoutes.ASSIGNMENT}
                    element={<Assignment />}
                  />
                  <Route
                    path={MainRoutes.TAG_LIBRARY_CONFIG}
                    element={<TagLibraryConfigList />}
                  />
                  <Route
                    path={MainRoutes.CREATE_TAG_LIBRARY_CONFIG}
                    element={<CreateTagLibraryConfig />}
                  />
                  <Route
                    path={MainRoutes.TAG_ENRICHMENT_PHASE}
                    element={<TagEnrichmentPage />}
                  />
                  <Route
                    path={MainRoutes.COMPLETE_TAG_LIBRARY_CONFIG}
                    element={<CompleteTagLibrary />}
                  />
                  <Route
                    path={MainRoutes.PROCESSING_HUB}
                    element={<UploadPage />}
                  />
                  <Route
                    path={MainRoutes.AI_CHATBOT}
                    element={<AIChatbotPage />}
                  />
                  <Route
                    path={MainRoutes.DATA_INTEGRATION_HUB}
                    element={<DataIntegration />}
                  />
                  <Route
                    path={MainRoutes.DATA_CLASSIFICATION_HUB}
                    element={<DataClassificationHub />}
                  />
                  <Route
                    path={MainRoutes.DATA_CLASSIFICATION_HISTORY}
                    element={<DocumentHistoryPage />}
                  />
                  <Route
                    path={MainRoutes.DATA_CLASSIFICATION_RESULTS}
                    element={<CategoriesOverviewPage />}
                  />
                  <Route
                    path={MainRoutes.DATA_CLASSIFICATION_DETAIL}
                    element={<CategoryDetailPage />}
                  />
                  <Route
                    path={MainRoutes.BATCH_EXTRACTION_RESULTS}
                    element={<BatchExtractionResultsPage />}
                  />
                  <Route
                    path={MainRoutes.BATCH_QUALITY_ASSESSMENT}
                    element={<BatchQualityAssessmentPage />}
                  />
                  <Route
                    path={MainRoutes.AVAILABLE_DETAILS}
                    element={<AvailableDataTable />}
                  />
                  <Route
                    path={MainRoutes.DATA_FILTER_BUILDER}
                    element={<DataFilterBuilderPage />}
                  />
                  <Route
                    path={MainRoutes.DATA_MAPPING_INTERFACE}
                    element={<DataMappingInterface />}
                  />
                  <Route
                    path={MainRoutes.PREDICTIVE_MAINTENANCE_DASHBOARD}
                    element={<PredictiveMaintenanceDashboard />}
                  />
                  <Route
                    path={MainRoutes.FLOW_BUILDER}
                    element={<FlowBuilder />}
                  />
                  <Route
                    path={MainRoutes.SNOWFLAKE_DATA_VIEWER}
                    element={<SnowflakeDataViewer />}
                  />
                  <Route
                    path={MainRoutes.KNOWLEDGE_LIBRARY}
                    element={<KnowledgeLibrary />}
                  />
                  <Route
                    path={MainRoutes.VIEW_KNOWLEDGE_DATA}
                    element={<ViewData />}
                  />
                  <Route
                    path={MainRoutes.SEARCH_DETAILS}
                    element={<SearchDetails />}
                  />
                  <Route
                    path={MainRoutes.KNOWLEDGE_AGENT}
                    element={<KnowledgeAgent />}
                  />
                  <Route
                    path={MainRoutes.AGENT_ALL_DETAILS}
                    element={<AgentAllDetails />}
                  />
                  <Route
                    path={MainRoutes.AGENT_SESSION_VIEW}
                    element={<AgentSessionView />}
                  />
                  <Route
                    path={MainRoutes.PACKAGING_WORKSPACE}
                    element={<PackagingWorkspace />}
                  />
                </Routes>
              </Suspense>
            </div>
            {/* <Footer /> */}
          </div>
        </main>
        {/* <FloatingChatbot /> */}
        <SessionTimeOutModal />
      </AuthProvider>
    </MsalAuthenticationTemplate>
  );
};

export default AuthorizedLayout;
